import React, { ReactNode } from 'react';

export const EmptyTable = ({ children }: { children: ReactNode | ReactNode[] }): JSX.Element => (
  <>{children}</>
);
